import { I18nUtil } from "@utils/i18n";
import Translations from "@translate/components/Member/CurrentPlan/SubscriptionExpiringNotice/index";
import { FC, memo } from "react";
import { MemberPlanInfo } from "@/src/hooks";

const I18n = I18nUtil.createScoped(Translations);

export const isSubscriptionExpiring = (data?: MemberPlanInfo) =>
  !!data?.remain_minutes && !data?.auto_renewal && !data?.isFree;

interface SubscriptionExpiringNoticeProps {
  data?: MemberPlanInfo;
  toMemberPrice: () => void;
}

/** 移动端：底部 Upgrade + Manage Billing 双按钮 */
export const SubscriptionExpiringActions: FC<SubscriptionExpiringNoticeProps> =
  memo(({ data, toMemberPrice }) => {
    if (!isSubscriptionExpiring(data)) {
      return null;
    }

    return (
      <button
        type="button"
        className="button md_button primary_button button_m w-full h-11 mb-2"
        onClick={toMemberPrice}
      >
        {I18n.t("Upgrade")}
      </button>
    );
  });

SubscriptionExpiringActions.displayName = "SubscriptionExpiringActions";
